import MobileDeviceMenu from './components/MobileDeviceMenu';
import StickyHeader from './components/StickyHeader';
import AuthHelper from './components/AuthHelper';
import GformHelper from './components/GformHelper';
import MoveMessage from './components/MoveMessage';

(function ($) {
    $( document ).ready(function() {
        $('.configurator-select-body .list').each(function(index){
            if(!$(this).find('.selected').length){
                $(this).children()[0].click();
            }
        });


        $('.promo-products .description .btn').on('click', function(e) {
            var box = $(this).closest('.box');
            productTitle = box.find('h3').text();
            localStorage.setItem('product_title', productTitle);

            localStorage.setItem('label_items', 1);
            var img = box.find('.image').clone().html();
            localStorage.setItem('label_preview', img);
        });

        $('.category-products .product-footer .btn').on('click', function(e) {
            var box = $(this).closest('.box');
            productTitle = box.find('.title a').text();
            localStorage.setItem('product_title', productTitle);

            localStorage.setItem('label_items', 1);
            var img = box.find('.image a').clone().html();
            localStorage.setItem('label_preview', img);
        });

        if($('#cart_message_modal').length) {
            // Get the modal
            var modal = document.getElementById("cart_message_modal");

            // Get the button that opens the modal
            var btn = document.getElementById("myBtn");

            // Get the <span> element that closes the modal
            var span = document.getElementsByClassName("close-modal")[0];

            var isSingleProduct = !$('#configurator-media-box').length;
            var isCategoryProduct = $('.category-products').length;
            if(isCategoryProduct) {
                $('#cart_message_modal #amount').text(1);
                var img = localStorage.getItem('label_preview');
                $('#label_preview_modal').html(img);
            }else if(isSingleProduct) {
                $('#cart_message_modal #amount').text(1);
                var img = $('.wp-post-image').clone().wrap("<div />").parent().html();
                $('#label_preview_modal').html(img);
            }else {
                var labelClone = localStorage.getItem('label_preview');
                $('#label_preview_modal').append($(labelClone).children());

                var labelItems = localStorage.getItem('label_items');
                $('#cart_message_modal #amount').text(labelItems);
            }

            var productTitle = localStorage.getItem('product_title');
            if(!productTitle) {
                productTitle = $('h1.product_title').text();
            }
            $('#cart_message_modal #product-title').text(productTitle);

            //btn.onclick = function() {
            modal.style.display = "block";
            $('#main > .container').addClass('blur');
            //}

            $('.woocommerce-message-inner').hide();

            span.onclick = function () {
                modal.style.display = "none";
                $('#main > .container').removeClass('blur');
            }

            // When the user clicks anywhere outside of the modal, close it
            window.onclick = function (event) {
                if (event.target == modal) {
                    modal.style.display = "none";
                    $('#main > .container').removeClass('blur');
                }
            }
        }

    });

    $('[data-toggle="tooltip"]').tooltip();
    $('.swipebox').swipebox();
    $('.gfield_checkbox label').append('<span class="brand-icon ill-check"><span class="path1"></span><span class="path2"></span></span>');

    if($('body').is('.single-product')) {
        let $form = $('form.cart');

        if($form.is('.variations_form')) {
            $(document).on('woocommerce_gallery_reset_slide_position', function () {
                initWooGalleryThumbs();
            });
        }else {
            let timeout = null;

            timeout = setInterval(() => {
                if($('.flex-control-nav').length) {
                    initWooGalleryThumbs();
                    clearInterval(timeout);
                }
            }, 500);
        }
    }

    function initWooGalleryThumbs() {
        let $controlNav = $('.flex-control-nav');

        if($controlNav.length) {
            $controlNav.addClass('owl-carousel');
            $controlNav.find('li').addClass('item');
            $controlNav.owlCarousel({
                loop: false,
                dots: false,
                nav: true,
                margin: 0,
                responsiveClass: true,
                navText: [
                    '<span class="brand-icon ill-angle-left"><span class="path1"></span><span class="path2"></span></span>',
                    '<span class="brand-icon ill-angle-right"><span class="path1"></span><span class="path2"></span></span>'
                ],
                responsive:{
                    0:{
                        items: 3
                    },
                    992:{
                        items: 4
                    },
                }
            });

            if($controlNav.find('.owl-nav').is('.disabled')) {
                $controlNav.addClass('few-items');
            }
        }
    }

    let $cartDiscount = $('body.page-template-template-cartpage .cart-discount');

    if($cartDiscount.length) {
        let $th = $cartDiscount.find('th');
        let $td = $cartDiscount.find('td');

        $th.html($td.data('title'));
    }

    $(window).on('load resize', function () {
        let $content = $('#content');

        $content.removeAttr('style');

        let bodyHeight = $('html').outerHeight(true);
        let windowHeight = $(window).height();

        if(bodyHeight < windowHeight) {

            let additionalHeight = windowHeight - bodyHeight;
            let contentHeight = $content.height();

            $content.css({
                'height': contentHeight + additionalHeight
            });
        }
    });

    let scrollTo = {
        init($block, padding = 0, speed = 1000) {
            if( $block.length ) {
                $('html, body').stop(true, true).animate({
                    scrollTop: $block.offset().top - padding
                }, speed);
            }else {
                console.log('block not found');
            }
        }
    };

    $(document).on('click', '.to-category-description', function () {
        let headerHeight = $('.page-header-fixed').height();

        scrollTo.init($('.sevencol-text'), headerHeight);

        return false;
    });

    let $searchWidget = $('.widget_product_search');

    if($searchWidget.length) {
        $searchWidget.find('button[type=submit]').html('<span class="brand-icon ill-search"><span class="path1"></span><span class="path2"></span></span>');
    }

    $(window).on('load', function () {
        if($('.page-template-template-faqpage').length && window.location.hash) {
            scrollTo.init($(window.location.hash), 130);
        }
    });

    // $('.woocommerce-Price-currencySymbol').each(function (index, el) {
    //     $(el).html(',-');
    // });

    $(window).on('load resize', function () {
        $('.text-more').each(function (index, el) {
            let limit = $(el).attr('data-limit-height');
            let id = $(el).attr('id');

            $(el).removeClass('show-less');
            $(`a[href="#${id}"]`).removeClass('d-none');

            limit = Number(limit);

            if($(el).height() > limit) {
                $(el).addClass('show-less');
            }else {
                $(`a[href="#${id}"]`).addClass('d-none');
            }
        });

        $('.show-more-reviews').each(function (index, el) {
            let $btn = $(el);
            let id = $btn.attr('href');

            $(id).css({
                'display': 'none'
            });
        });
    });

    $(document).on('click', '.coupon-collapse-handler', function () {
        $(this).next().stop(true, true).slideToggle(500);

        return false;
    }).on('click', '.show-review-form', function () {
        let $btn = $(this);
        let id = $btn.attr('href');

        $(id).stop(true, true).slideDown();
        $btn.hide();

        return false;
    }).on('click', '.show-more-reviews', function () {
        let $btn = $(this);
        let id = $btn.attr('href');
        let text = $btn.attr('data-more');
        let $icon = $btn.find('.brand-icon');

        if($btn.is('.more')) {
            $(id).stop(true, true).slideUp(500);
            $btn.removeClass('more');
            $icon.removeClass('ill-angle-up').addClass('ill-angle-down');
        }else {
            text = $btn.attr('data-less');
            $(id).stop(true, true).slideDown(500);
            $btn.addClass('more');
            $icon.removeClass('ill-angle-down').addClass('ill-angle-up');
        }

        $btn.find('.text').html(text);

        return false;
    }).on('click', '.button-more', function () {
        let $btn = $(this);
        let id = $btn.attr('href');
        let $icon = $btn.find('.brand-icon');

        if($btn.is('.state-more')) {
            let less = $btn.attr('data-less');

            $btn.find('.text').html(less);
            $icon.removeClass('ill-angle-down').addClass('ill-angle-up');
            $btn.removeClass('state-more').addClass('state-less');
            $(id).addClass('show-more').removeClass('show-less');
        }else if($btn.is('.state-less')) {
            let more = $btn.attr('data-more');

            $btn.find('.text').html(more);
            $icon.removeClass('ill-angle-up').addClass('ill-angle-down');
            $btn.removeClass('state-less').addClass('state-more');
            $(id).removeClass('show-more').addClass('show-less');
        }

        return false;
    }).on('hide.bs.collapse', '.answer', function () {
        $(this).closest('.faq-item').removeClass('show');
    }).on('shown.bs.collapse','.answer', function () {
        $(this).closest('.faq-item').addClass('show');
    }).on('click', '.scroll-to', function (e) {
        let id = $(this).attr('href');

        scrollTo.init($(id), 130);
    }).on('click', '#news-form .btn', function () {
        let $btn = $(this);
        let $form = $btn.closest('form');
        let $field = $form.find('#news-filter');
        let data = $field.val();
        let slug = $btn.attr('href');
        let dataArr = [];

        if(data.length) {
            dataArr = data.split(',');
        }

        if($btn.is('.except')) {
            $btn.removeClass('except');
            let removeIndex = null;

            dataArr.forEach((item, index) => {
                if(item === slug) {
                    removeIndex = index;
                }
            });

            if(removeIndex !== null) {
                dataArr.splice(removeIndex, 1);
            }
        }else {
            $btn.addClass('except');
            dataArr.push(slug);
        }

        $('#site-loader').fadeIn();
        $field.val(dataArr.join(','));
        $form.submit();

        return false;
    });

    new AuthHelper();
    new GformHelper();

    new MoveMessage({
        data: [
            {
                selector: '.woocommerce-edit-account .woocommerce-error',
                to: '.woocommerce-notices-wrapper'
            },
            {
                selector: '.woocommerce-edit-address .woocommerce-error',
                to: '.woocommerce-notices-wrapper',
                classTo: '.form-row'
            },
            {
                selector: 'body.tax-product_cat .woocommerce-message',
                to: '.category-products .woocommerce-notices-wrapper'
            },
            {
                selector: 'body.search-results .woocommerce-message',
                to: '.category-products .woocommerce-notices-wrapper'
            },
            {
                selector: 'body.single-product .woocommerce-message',
                to: '#main .woocommerce-notices-wrapper'
            },
            {
                selector: 'body.page-template-template-cartpage .woocommerce-info',
                to: '#main .woocommerce-notices-wrapper'
            },
            {
                selector: 'body.page-template-template-cartpage .woocommerce-message',
                to: '#main .woocommerce-notices-wrapper'
            },
            {
                selector: 'body.page-template-template-cartpage .woocommerce-error',
                to: '#main .woocommerce-notices-wrapper'
            },
            {
                selector: 'body.woocommerce-checkout .woocommerce-error',
                to: 'form#order_review',
                type: 'prepend',
            },
            {
                selector: 'body.woocommerce-checkout .woocommerce-message',
                to: 'form#order_review',
                type: 'prepend',
            },
            {
                selector: 'body.woocommerce-checkout .woocommerce-info',
                to: 'form#order_review',
                type: 'prepend',
            },
            {
                selector: 'body.configurator-product .woocommerce-error',
                to: '.container > .product',
                type: 'prepend',
            }
        ]
    });

    $.magicCols.init({
        col: '.promo-products-list .box',
        children: {
            image: '.image',
            title: 'h3',
            description: '.excerpt'
        }
    });

    new MobileDeviceMenu({
        'container': '#mobile-menu',
        'active_class': [
            '.current-menu-item',
            '.current_page_parent'
        ],
        'special_class': '.special-item',
        'logo': '#logo',
        'menu': [
            '#menu-header-bottom',
            '#menu-header-top',
            '#menu-mobile-menu-left'
        ],
        'after': []
    });

    new StickyHeader({
        'stickyAfterSelector': '.page-header-top',
        'stickySelector': '.page-header-bottom',
    });

    $('#gallery-images').owlCarousel({
        loop: false,
        nav: true,
        margin: 10,
        responsiveClass: true,
        navText: [
            '<span class="brand-icon ill-angle-left"><span class="path1"></span><span class="path2"></span></span>',
            '<span class="brand-icon ill-angle-right"><span class="path1"></span><span class="path2"></span></span>'
        ],
        responsive:{
            0:{
                items: 2,
                dots: true,
                nav: false
            },

        }
    });

    $('#instagram-carousel').owlCarousel({
        loop: true,
        responsiveClass: true,
        navText: [
            '<span class="brand-icon ill-angle-left"><span class="path1"></span><span class="path2"></span></span>',
            '<span class="brand-icon ill-angle-right"><span class="path1"></span><span class="path2"></span></span>'
        ],
        responsive:{
            0:{
                items: 2,
                margin: 5,
                dots: true,
                nav: false
            },
            600:{
                items: 3,
                margin: 5,
                dots: true,
                nav: false
            },
            768:{
                items: 4,
                margin: 5,
                dots: false,
                nav: true
            },
            1200:{
                items: 6,
                margin: 5,
                dots: false,
                nav: true
            }
        }
    });

    $('#promo-categories-carousel').owlCarousel({
        loop: true,
        responsiveClass: true,
        navText: [
            '<span class="brand-icon ill-angle-left"><span class="path1"></span><span class="path2"></span></span>',
            '<span class="brand-icon ill-angle-right"><span class="path1"></span><span class="path2"></span></span>'
        ],
        responsive:{
            0:{
                items: 1.5,
                margin: 60,
                dots: false,
                nav: false
            },
            568:{
                items: 2,
                margin: 5,
                dots: false,
                nav: false
            },
            768:{
                items: 3,
                margin: 5,
                dots: false,
                nav: true
            },
        }
    });

    $('#shop-categories-carousel').owlCarousel({
        loop: true,
        responsiveClass: true,
        navText: [
            '<span class="brand-icon ill-angle-left"><span class="path1"></span><span class="path2"></span></span>',
            '<span class="brand-icon ill-angle-right"><span class="path1"></span><span class="path2"></span></span>'
        ],
        responsive:{
            0:{
                items: 1.5,
                margin: 20,
                dots: false,
                nav: false
            },
            568:{
                items: 2,
                margin: 20,
                dots: false,
                nav: false
            },
            768:{
                items: 4,
                margin: 20,
                dots: false,
                nav: true
            },
        }
    });

    $('#home-slider, #home-slider-mobile').owlCarousel({
        loop: false,
        responsiveClass: true,
        navText: [
            '<span class="brand-icon ill-angle-left"><span class="path1"></span><span class="path2"></span></span>',
            '<span class="brand-icon ill-angle-right"><span class="path1"></span><span class="path2"></span></span>'
        ],
        responsive:{
            0:{
                items: 1,
                margin: 0,
                dots: true,
                nav: false
            },
            768:{
                items: 1,
                dots: false,
                nav: true
            },
        }
    });

    $('#promo-list-carousel').owlCarousel({
        loop: true,
        margin: 10,
        responsiveClass: true,
        navText: [
            '<span class="brand-icon ill-angle-left"><span class="path1"></span><span class="path2"></span></span>',
            '<span class="brand-icon ill-angle-right"><span class="path1"></span><span class="path2"></span></span>'
        ],
        responsive:{
            0:{
                items: 1.5,
                dots: false,
                nav: false
            },
            768:{
                items: 2,
                dots: false,
                nav: true
            },
            820:{
                items: 3,
                dots: false,
                nav: true
            },
        }
    });

    $('#reviews-carousel').owlCarousel({
        loop: true,
        margin: 0,
        responsiveClass: true,
        navText: [
            '<span class="brand-icon ill-angle-left"><span class="path1"></span><span class="path2"></span></span>',
            '<span class="brand-icon ill-angle-right"><span class="path1"></span><span class="path2"></span></span>'
        ],
        responsive:{
            0:{
                items: 1,
                dots: true,
                nav: false
            },
            768:{
                items: 2,
                dots: false,
                nav: true
            },
            1200:{
                items: 3,
                dots: false,
                nav: true
            },
        }
    });

    $('#promo-products-carousel').owlCarousel({
        loop: true,
        responsiveClass: true,
        autoHeight: true,
        navText: [
            '<span class="brand-icon ill-angle-left"><span class="path1"></span><span class="path2"></span></span>',
            '<span class="brand-icon ill-angle-right"><span class="path1"></span><span class="path2"></span></span>'
        ],
        responsive:{
            0:{
                margin: 0,
                items: 1,
                dots: true,
                nav: false
            },
            1024:{
                margin: 0,
                items: 2,
                dots: false,
                nav: true
            },
        }
    });

    const $toppersCarousel = $('#toppers-carousel').owlCarousel({
        loop: true,
        responsiveClass: true,
        navText: [
            '<span class="brand-icon ill-angle-left"><span class="path1"></span><span class="path2"></span></span>',
            '<span class="brand-icon ill-angle-right"><span class="path1"></span><span class="path2"></span></span>'
        ],
        responsive:{
            0:{
                items: 1.5,
                margin: 0,
                dots: false,
                nav: false
            },
            600:{
                items: 3,
                margin: 0,
                dots: false,
                nav: false
            },
            992:{
                items: 3,
                margin: 0,
                dots: false,
                nav: true
            },
        }
    });

    $(document).on('click', '.toppers-next-btn', function() {
        $toppersCarousel.trigger('next.owl.carousel');
    })

    $(window).on('load', function() {
        let $confirmationWrapper = $('.gform_confirmation_wrapper');

        if($confirmationWrapper.length) {
            $confirmationWrapper.next('.form-required-label').remove();
        }

        if($('body.woocommerce-account').length) {
            if(!$('#billing_country').next('.select2').length) {
                $('#billing_country').select2();
            }

            if(!$('#shipping_country').next('.select2').length) {
                $('#shipping_country').select2();
            }
        }
    });

    let isCheckout = $('body.page-template-template-checkoutpage').length;
    let isFormOrderReview = $('form#order_review').length;
    let isCompleteActive = $('.item.complete.active').length;

    if(!isCheckout || (isCheckout && isFormOrderReview) || isCompleteActive) {
        $.siteLoader.init('#site-loader');
    }
    $(".variations_form").keydown(function(event){
      if(event.keyCode == 13) {
        event.preventDefault();
        $('#configurator_first_name, #configurator_last_name').blur();
        return false;
      }
    });
    //let isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
    if($('#configurator-media-wrapper').length && getWidth() < 760) {

        //Disable to go on bottom/message textarea, after last name field
        $('#configurator_last_name').bind('keydown', function (e) {
            if (e.keyCode == 9) {
                return false;
            }
        });

        let stickyBlock = $('#configurator-media-wrapper').parent();
        let blurTimer;
        //let h = $('#configurator-media-box').offsetHeight; alert(h); undefined? After image loaded - set this min-height
        let fields = $('#configurator_first_name, #configurator_last_name');
        fields.on('focus', function(){
          // stickyBlock.removeClass('sticky-top');
          stickyBlock.css('position', 'inherit');
          clearTimeout(blurTimer);
        });
        fields.on('blur', function(){
          // stickyBlock.addClass('sticky-top');
          stickyBlock.css('position', 'sticky');
          const el = document.getElementById('main');
          clearTimeout(blurTimer);
          blurTimer = setTimeout(function () {
            el.scrollIntoView();
          }, 100);
        });
        $('#configurator_personal_message').on('focus', function(){
          stickyBlock.removeClass('sticky-top');
          stickyBlock.css('position', 'relative');
        });
        $('#configurator_personal_message').on('blur', function(){
          stickyBlock.addClass('sticky-top');
          stickyBlock.css('position', 'sticky');
        });
        document.addEventListener("DOMContentLoaded", function () {
            window.addEventListener('scroll', function () {
                if (window.scrollY > ($('.lighter-steps').offset().top - ($('#configurator-media-wrapper').innerHeight()))) {
                    // stickyBlock.removeClass('sticky-top');
                  $('.product').css('height', $('.product').height());
                  $('.product .row').css('height', $('.product').height() - $('.lighter-steps').outerHeight());
                }else{
                    // stickyBlock.addClass('sticky-top');
                  $('.product').css('height', 'auto');
                  $('.product .row').css('height', 'auto');
                }
            });
        });
    }


  $(document).on('woocommerce_gallery_init_zoom', function () {
    $(window).on('load resize', function() {
      if (getWidth() < 760) {
        setTimeout(()=>{
          var owl = $('#preview-carousel');
          owl.owlCarousel('destroy');
          let content = '';
          let sticker = $('.flex-viewport .woocommerce-product-gallery__image .sticker-gallery-preview');
          if (sticker.length) {
            let imgOverlay = sticker[0].outerHTML;
            imgOverlay = '<span class="overlay">' + imgOverlay + '</span>';
            $('.flex-viewport .woocommerce-product-gallery__image').each(function () {
              content += '<a href="#"><img src="' + $(this).find('img').attr('src') + '">' + imgOverlay + '</a>';
            });
            owl.html(content);

            owl.owlCarousel({
              nav: true,
              autoHeight: false,
              navText: [
                '<span class="brand-icon ill-angle-left"><span class="path1"></span><span class="path2"></span></span>',
                '<span class="brand-icon ill-angle-right"><span class="path1"></span><span class="path2"></span></span>'
              ],
              loop: true,
              responsive: {
                0: {
                  items: 1
                },
              }
            });
          }
        }, 2000);
      }
    });
  });

}(jQuery));

function getWidth() {
    return Math.max(
        document.body.scrollWidth,
        document.documentElement.scrollWidth,
        document.body.offsetWidth,
        document.documentElement.offsetWidth,
        document.documentElement.clientWidth
    );
}